import {ReRelative} from '../../interfaces/relatives/re-relative';
import {ReRelationTypeFactory} from './re-relation-type-factory';

export class ReRelativeFactory {

  /**
   *
   * @param reRelative
   */
  public static fromObject(reRelative: any): ReRelative {
    return new class implements ReRelative {
      countryId: number = reRelative.country_id;
      fullRoute: string = reRelative.full_route;
      district: string = reRelative.district;
      door: string = reRelative.door;
      firstName: string = reRelative.first_name;
      floor: string = reRelative.floor;
      genderId: number = reRelative.gender_id;
      id: number = reRelative.id;
      lastName: string = reRelative.last_name;
      customId: number = reRelative.custom_id;
      fullName: string = reRelative.full_name;
      locality: string = reRelative.locality;
      phone3: string = reRelative.phone_3;
      phone2: string = reRelative.phone_2;
      phone1: string = reRelative.phone_1;
      email: string = reRelative.email;
      comment: string = reRelative.comment;
      postalCode: string = reRelative.postal_code;
      province: string = reRelative.province;
      route: string = reRelative.route;
      streetNumber: string = reRelative.street_number;
      titlePrefix: string = reRelative.title_prefix;
      titleSuffix: string = reRelative.title_suffix;
      serviceFacilityId: number = reRelative.service_facility_id;
      reRelationTypeId: number = reRelative.re_relation_type_id;
      reRelationType =
        reRelative.re_relation_type ? ReRelationTypeFactory.fromObject(reRelative.re_relation_type) : null;
      name: string = reRelative.name;
    };
  }

  /**
   *
   * @param reRelatives
   */
  public static fromArray(reRelatives: any[]): ReRelative[] {
    return reRelatives.map(_reRelative => ReRelativeFactory.fromObject(_reRelative));
  }
}
